/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'heart-filled': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M83.332 27.082C81.039 22.914 66.664 8.957 50 29.164c-17.5-20.207-31.043-6.25-33.332-2.082-4.168 7.707-1.668 19.375 4.168 25L50.004 81.25l29.168-29.168c5.828-5.625 8.328-17.289 4.16-25z"/>'
  }
})
